import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRestroom,
  faWheelchair,
  faMosque,
  faPersonRunning,
  faKitMedical,
  faBicycle,
  faSquareParking,
  faSearch,
  faEnvelope,
  faPhone,
  faTriangleExclamation,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";

export default function ContactsPanel({}) {

  const [search, setSearch] = useState("");
  const [emergencyMode, setEmergencyMode] = useState(false);

  const facilities = [
    { id: 1, label: "Toilets", icon: faRestroom },
    { id: 2, label: "Accessible Doors", icon: faWheelchair },
    { id: 3, label: "Prayer Room", icon: faMosque },
    { id: 4, label: "Fire Exits", icon: faPersonRunning },
    { id: 5, label: "First Aid", icon: faKitMedical },
    { id: 6, label: "Bike Storage", icon: faBicycle },
    { id: 7, label: "Parking", icon: faSquareParking }
  ];

  const people = [
    {
      id: 1,
      name: "Jane Smith",
      role: "Facilities Manager",
      email: "jane.smith@diamond.com",
      phone: "0113 123 4567",
      photo: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    {
      id: 2,
      name: "Mark Turner",
      role: "Fire Safety Officer",
      email: "mark.turner@diamond.com",
      phone: "0113 765 4321",
      photo: "https://randomuser.me/api/portraits/men/46.jpg",
      isFireWarden: true
    },
    {
      id: 3,
      name: "Aisha Khan",
      role: "HR Partner",
      email: "aisha.khan@diamond.com",
      phone: "0113 222 8899",
      photo: "https://randomuser.me/api/portraits/women/68.jpg"
    },
    {
      id: 4,
      name: "Tom Reynolds",
      role: "IT Support",
      email: "tom.reynolds@diamond.com",
      phone: "0113 444 3322",
      photo: "https://randomuser.me/api/portraits/men/52.jpg"
    }
  ];

  const fireWarden = people.find(p => p.isFireWarden);

  const filteredPeople = people.filter(p =>
    (p.name + p.role)
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  /* ===========================
     STYLES
     =========================== */

  const container = {
    display: "flex",
    height: "100%",
    gap: "16px",
    flexDirection: "column"
  };

  const panelRow = {
    display: "flex",
    gap: "16px",
    flex: 1
  };

  const panel = {
    background: "#ffffff",
    borderRadius: "14px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
    padding: "18px",
    flex: 1,
    display: "flex",
    flexDirection: "column"
  };

  const sectionTitle = {
    fontSize: "13px",
    fontWeight: 700,
    color: "#111",
    marginBottom: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.6px"
  };

  const peopleSearch = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 12px",
    borderRadius: "10px",
    border: "1px solid #e6e6e6",
    marginBottom: "14px",
    background: "#fafafa"
  };

  const personCard = {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid #eee",
    background: "#ffffff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    marginTop: "20px"   // 👈 spacing added
  };

  const emergencyHeader = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 16px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #c0392b, #8e0b0b)",
    color: "#fff",
    marginBottom: "16px",
    boxShadow: "0 8px 18px rgba(0,0,0,0.25)"
  };

  const emergencySplit = {
    display: "flex",
    gap: "16px",
    flex: 1
  };

  const emergencyBox = {
    flex: 1,
    borderRadius: "12px",
    background: "#fff",
    border: "1px solid #eee",
    padding: "14px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
  };

  /* ===========================
     EMERGENCY MODE RENDER
     =========================== */

  if (emergencyMode) {
    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>

        {/* Emergency Toggle */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
          <button
            onClick={() => setEmergencyMode(false)}
            style={{
              background: "#c0392b",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              padding: "10px 16px",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)"
            }}
          >
            Exit Emergency Mode
          </button>
        </div>

        {/* Fire Warden Header */}
        <div style={emergencyHeader}>
          <FontAwesomeIcon icon={faTriangleExclamation} fontSize="22px" />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: "14px" }}>Emergency Mode</div>
            <div style={{ fontSize: "12px", opacity: 0.85 }}>Fire Warden & Evacuation Plan</div>
          </div>
        </div>

        {/* Fire Warden Card */}
        {fireWarden && (
          <div style={{ ...panel, marginBottom: "16px", background: "#fff5f5", border: "1px solid #f1b0b0" }}>
            <div style={sectionTitle}>Fire Warden</div>
            <div style={personCard}>
              <img
                src={fireWarden.photo}
                alt={fireWarden.name}
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                }}
              />
              <div>
                <div style={{ fontWeight: 700 }}>{fireWarden.name}</div>
                <div style={{ color: "#c0392b", fontWeight: 600 }}>{fireWarden.role}</div>
                <div style={{ fontSize: "12px" }}>
                  <FontAwesomeIcon icon={faPhone} /> {fireWarden.phone}
                </div>
                <div style={{ fontSize: "12px" }}>
                  <FontAwesomeIcon icon={faEnvelope} /> {fireWarden.email}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Emergency Split */}
        <div style={emergencySplit}>
          <div style={emergencyBox}>
            <div style={sectionTitle}>Evacuation Floorplan</div>
            <div style={{
              height: "100%",
              background: "#fafafa",
              borderRadius: "10px",
              border: "1px dashed #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              fontSize: "13px",
              gap: "8px"
            }}>
              <FontAwesomeIcon icon={faFilePdf} />
              Floorplan PDF Placeholder
            </div>
          </div>

          <div style={emergencyBox}>
            <div style={sectionTitle}>Emergency Instructions</div>
            <ol style={{ paddingLeft: "18px", fontSize: "13px", lineHeight: "1.6", color: "#333" }}>
              <li>Raise the fire alarm immediately.</li>
              <li>Call emergency services and report location.</li>
              <li>Assist occupants towards nearest exits.</li>
              <li>Check all rooms and corridors.</li>
              <li>Guide people to assembly point.</li>
              <li>Report clear status to Fire Officer.</li>
            </ol>
          </div>
        </div>
      </div>
    );
  }

  /* ===========================
     NORMAL CONTACTS MODE
     =========================== */

  return (
    <div style={container}>

      {/* Emergency Toggle */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
        <button
          onClick={() => setEmergencyMode(true)}
          style={{
            background: "#f4c400",
            color: "#000",
            border: "none",
            borderRadius: "10px",
            padding: "10px 16px",
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)"
          }}
        >
          Emergency Mode
        </button>
      </div>

      <div style={panelRow}>
        {/* LEFT: Facilities */}
        <div style={panel}>
          <div style={sectionTitle}>Places & Facilities</div>
          {facilities.map(item => (
            <div
              key={item.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 14px",
                borderRadius: "10px",
                cursor: "pointer",
                border: "1px solid #f0f0f0",
                marginBottom: "10px",
                background: "#fafafa"
              }}
            >
              <FontAwesomeIcon icon={item.icon} style={{ color: "#f4c400", width: "16px" }} />
              <span style={{ fontWeight: 600 }}>{item.label}</span>
            </div>
          ))}
        </div>

        {/* RIGHT: People */}
        <div style={panel}>
          <div style={sectionTitle}>People Directory</div>

          <div style={peopleSearch}>
            <FontAwesomeIcon icon={faSearch} color="#999" />
            <input
              type="text"
              placeholder="Search staff by name or role..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                width: "100%",
                fontSize: "13px",
                background: "transparent"
              }}
            />
          </div>

          {filteredPeople.map(person => (
            <div key={person.id} style={personCard}>
              <img
                src={person.photo}
                alt={person.name}
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                }}
              />
              <div>
                <div style={{ fontWeight: 700 }}>{person.name}</div>
                <div style={{ color: "#f4c400", fontWeight: 600 }}>{person.role}</div>
                <div style={{ fontSize: "12px" }}>
                  <FontAwesomeIcon icon={faEnvelope} /> {person.email}
                </div>
                <div style={{ fontSize: "12px" }}>
                  <FontAwesomeIcon icon={faPhone} /> {person.phone}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
